"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseToken = exports.getToken = void 0;

var _jwtDecode2 = _interopRequireDefault(require("jwt-decode"));

var getToken = function getToken() {
  var search = new URL(window.location).searchParams;
  var token = search.get('token');
  return token || JSON.parse(window.localStorage.getItem('token'));
};

exports.getToken = getToken;

var parseToken = function parseToken(token) {
  try {
    var _jwtDecode = (0, _jwtDecode2["default"])(token),
        iss = _jwtDecode.iss,
        userRoles = _jwtDecode.userRoles;

    return {
      parsedEnv: iss.split('.')[0],
      userRoles: userRoles
    };
  } catch (e) {
    return {};
  }
};

exports.parseToken = parseToken;